import React from 'react';

import Paper from '@material-ui/core/Paper';

import commonStyles from '../pages/styles.css';

export default function PageContainer({ children, ...props }) {
  return <Paper className={commonStyles.container} {...props}>{children}</Paper>;
}
